export const SET_CATEGORY_TRANSACTIONS = 'SET_CATEGORY_TRANSACTIONS'
